// from JSP?
/* global teacherId */

// checks if the user started on the teacher page.
export function isFirstPageInBrowserSession() {
    const sessionRefferingURLCookie = unescape(window.readCookie('sessionURL'));
    if (sessionRefferingURLCookie == null) {
        return true;
    }

    const cookieValue = sessionRefferingURLCookie.split('###');
    const landingPage = cookieValue.length > 1 ? cookieValue[1] : '';

    // Both id-based teacher URLs and vanity teacher URLs show up with classroom/ in the URL in the sessionReferralURL cookie
    if (landingPage !== '') {
        const weteach = landingPage.split('classroom/');
        const teacher = weteach.length > 1 ? weteach[1] : '';

        if (teacher === '') {
            return false;
        } else {
            let id = teacher.split('?');
            id = id[0];
            if (teacherId != id) {
                return false;
            }
        }
    }

    return true;
}
